import { useState } from "react";
import Header from "@/components/Header";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Play, Film, Stars, Clock } from "lucide-react";

const AnimatedFilm = () => {
  const { language, setLanguage, content: currentContent } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <Header 
        language={language} 
        onLanguageChange={setLanguage}
        content={currentContent.header}
      />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-20 px-4">
          <div className="container mx-auto max-w-4xl text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="hero-text">{currentContent.services.services[3].title}</span>
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
              {currentContent.services.services[3].description}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                asChild 
                size="lg" 
                className="bg-gradient-primary border-0 hover:opacity-90"
              >
                <a 
                  href="https://volym.typeform.com/to/vvm1IndH?utm_source=xxxxx&utm_campaign=xxxxx&utm_content=xxxxx" 
                  target="_self"
                >
                  {currentContent.header.cta}
                </a>
              </Button>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-20 px-4 bg-secondary/30">
          <div className="container mx-auto max-w-6xl">
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center p-6">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Film className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3">{currentContent.services.services[3].features[0]}</h3>
                <p className="text-muted-foreground">
                  {language === "sv" ? "Full kreativ kontroll över stil, karaktärer, miljöer och berättelse." : "Full creative control over style, characters, environments and storytelling."}
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Stars className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3">{currentContent.services.services[3].features[1]}</h3>
                <p className="text-muted-foreground">
                  {language === "sv" ? "Högkvalitativa animationer med professionell röst och ljuddesign." : "High-quality animations with professional voice and sound design."}
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Clock className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3">{currentContent.services.services[3].features[2]}</h3>
                <p className="text-muted-foreground">
                  {language === "sv" ? "AI-assisterad produktion för snabbare leverans utan att kompromissa med kvaliteten." : "AI-assisted production for faster delivery without compromising quality."}
                </p>
              </div>
            </div>
          </div>
        </section>


        <ContactSection content={currentContent.contact} />
      </main>
      
      <Footer 
        content={{
          company: "Volym Digitalbyrå AB",
          rights: language === "sv" ? "Alla rättigheter förbehållna." : "All rights reserved."
        }}
      />
    </div>
  );
};

export default AnimatedFilm;